/* eslint-disable react/prop-types */
import React from 'react';
import { ASelectCreate } from 'components/Antd';
import ADatePicker from 'components/Antd/DatePicker';
import FormItem from 'views/DesktopReview/components/FormItem';
import classes from './AddDataModal.module.scss';

const CertificateField = ({
  handleCreateType,
  handleCreateIssueParty,
  handleCreateScore,
  complianceTypeOptions,
  issuePartyOptions,
  scoreOptions,
  isRenew,
  disabled,
}) => {
  return (
    <>
      <div className={classes.line12}>
        <FormItem
          label="Type"
          name="type"
          required={!disabled}
          rules={disabled ? undefined : [{ required: true, message: 'This field is required!' }]}>
          <ASelectCreate
            placeholder="Fill or select"
            options={complianceTypeOptions}
            showSearch
            disabled={disabled || isRenew}
            size="large"
            radius="md"
            name="type"
            allowClear
            onCreate={handleCreateType}
          />
        </FormItem>
        <FormItem
          label="Issue Party"
          name="issueParty"
          required={!disabled}
          rules={disabled ? undefined : [{ required: true, message: 'This field is required!' }]}>
          <ASelectCreate
            placeholder="Fill or select"
            options={issuePartyOptions}
            showSearch
            size="large"
            radius="md"
            name="issueParty"
            allowClear
            onCreate={handleCreateIssueParty}
            disabled={disabled}
          />
        </FormItem>
      </div>
      <div className={classes.line12}>
        <FormItem label="Score / Overall Rating" name="score">
          <ASelectCreate
            placeholder="Fill or select"
            options={scoreOptions}
            showSearch
            size="large"
            radius="md"
            name="score"
            allowClear
            onCreate={handleCreateScore}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label="Expiry Date" name="expiryDate">
          <ADatePicker
            name="expiryDate"
            size="large"
            radius="md"
            placeholder="Select date"
            disabled={disabled}
          />
        </FormItem>
      </div>
      <FormItem label="Certificate Date / Report Date" name="testDate">
        <ADatePicker
          name="testDate"
          size="large"
          radius="md"
          placeholder="Select date"
          disabled={disabled}
        />
      </FormItem>
    </>
  );
};

export default CertificateField;
